"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailedAttendancesOnShifts = exports.DetailedAttendancesOnShift = void 0;
const price_1 = require("../value-objects/price");
class DetailedAttendancesOnShift {
    constructor(shiftId, childAttendances, crewAttendances) {
        this.shiftId = shiftId;
        this.childAttendances = childAttendances;
        this.crewAttendances = crewAttendances;
    }
    /**
     * Check if a given child attended this shift
     */
    didChildAttend(childId) {
        return !!this.childAttendances[childId] && this.childAttendances[childId].didAttend;
    }
    /**
     * Check if a given crew member attended this shift
     */
    didCrewMemberAttend(crewId) {
        return !!this.crewAttendances[crewId] && this.crewAttendances[crewId].didAttend;
    }
    /**
     * Get an array of child id's that attended this shift
     */
    attendingChildren() {
        return Object.keys(this.childAttendances).filter(childId => this.didChildAttend(childId));
    }
    /**
     * Get an array of crew member id's that attended this shift
     */
    attendingCrewMembers() {
        return Object.keys(this.crewAttendances).filter(crewId => this.didCrewMemberAttend(crewId));
    }
    /**
     * For the given child, check how much they paid for the shifts they attended
     * If they did not attend, or were not registered, return a zero price
     */
    amountPaidByChild(childId) {
        if (this.didChildAttend(childId)) {
            return new price_1.Price(this.childAttendances[childId].amountPaid);
        }
        else {
            return price_1.Price.zero;
        }
    }
}
exports.DetailedAttendancesOnShift = DetailedAttendancesOnShift;
class DetailedAttendancesOnShifts {
    constructor(detailedAttendancesOnShift) {
        this.detailedAttendancesOnShift = detailedAttendancesOnShift;
        if (new Set(detailedAttendancesOnShift.map(x => x.shiftId)).size !== detailedAttendancesOnShift.length) {
            throw new Error("detailedChildAttendancesOnShift may not contain two shifts with the same id");
        }
    }
    /**
     * Get the number of unique child attendances on given shifts
     *
     * @param onShifts The shifts to consider. If undefined, consider all shifts the object has
     */
    uniqueChildAttendances(onShifts) {
        const allShiftIds = this.detailedAttendancesOnShift.map(attendances => attendances.shiftId);
        const allAttendances = this.detailedAttendancesOnShift
            .filter(detailedAttendances => (onShifts || allShiftIds).indexOf(detailedAttendances.shiftId) !== -1)
            .map(detailedAttendances => detailedAttendances.attendingChildren());
        const set = new Set();
        allAttendances.forEach(attendances => attendances.forEach(attendance => set.add(attendance)));
        return set.size;
    }
    /**
     * Get the number of unique crew attendances on given shifts
     *
     * @param onShifts The shifts to consider. If undefined, consider all shifts the object has
     */
    uniqueCrewMemberAttendances(onShifts) {
        const allShiftIds = this.detailedAttendancesOnShift.map(attendances => attendances.shiftId);
        const allAttendances = this.detailedAttendancesOnShift
            .filter(detailedAttendances => (onShifts || allShiftIds).indexOf(detailedAttendances.shiftId) !== -1)
            .map(detailedAttendances => detailedAttendances.attendingCrewMembers());
        const set = new Set();
        allAttendances.forEach(attendances => attendances.forEach(attendance => set.add(attendance)));
        return set.size;
    }
    /**
     * Returns the number of shifts a crew member attended
     */
    numberOfCrewMemberAttendances(crewId) {
        return this.detailedAttendancesOnShift.reduce((previousValue, currentValue) => {
            return previousValue + (currentValue.didCrewMemberAttend(crewId) ? 1 : 0);
        }, 0);
    }
    /**
     * Returns the number of shifts a child attended
     */
    numberOfChildAttendances(childId) {
        return this.detailedAttendancesOnShift.reduce((previousValue, currentValue) => {
            return previousValue + (currentValue.didChildAttend(childId) ? 1 : 0);
        }, 0);
    }
    /**
     * Check if a given crew member did attend on a specific shift
     */
    didCrewMemberAttend(crewId, shiftId) {
        const attendancesForShift = this.detailedAttendancesOnShift.find(att => att.shiftId === shiftId);
        if (!attendancesForShift) {
            return false;
        }
        else {
            return attendancesForShift.didCrewMemberAttend(crewId);
        }
    }
    /**
     * Check if a given child did attend on a specific shift
     */
    didChildAttend(childId, shiftId) {
        const attendancesForShift = this.detailedAttendancesOnShift.find(att => att.shiftId === shiftId);
        if (!attendancesForShift) {
            return false;
        }
        else {
            return attendancesForShift.didChildAttend(childId);
        }
    }
    /**
     * For the given child, check how much they paid for the shifts they attended
     * If they did not attend, or were not registered, return a zero price
     */
    amountPaidByChild(childId) {
        return price_1.Price.total(...this.detailedAttendancesOnShift.map(x => x.amountPaidByChild(childId)));
    }
}
exports.DetailedAttendancesOnShifts = DetailedAttendancesOnShifts;
//# sourceMappingURL=detailed-attendance.js.map